import React from 'react';
import { DownloadIcon } from 'lucide-react';

/* Replace with your own file's share link if you upload a new version */
const CV_FILE_ID = '1mvYRzuQvHij6ooz1b0KaBKv9Ii8Kzhlt';
const CV_DOWNLOAD_URL = `https://drive.google.com/uc?export=download&id=${CV_FILE_ID}`;
export function CvDownloadButton() {
  return <a href={CV_DOWNLOAD_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full border border-charcoal/25 px-6 py-3 text-sm font-medium text-charcoal transition-colors duration-300 hover:border-amber hover:text-amber focus:outline-none focus-visible:ring-2 focus-visible:ring-amber focus-visible:ring-offset-2" data-id="element-28" data-mp="2iwmy1wjpltlp">
      <DownloadIcon size={17} aria-hidden="true" data-id="element-29" data-mp="31upgttlnyub2" />
      Download CV (PDF)
    </a>;
}